import {
  AccordionGroup,
  AccordionPanel,
  Accordion,
  AccordionHeader, H1,
} from "@salt-ds/core";
import ReactHtmlParser from "react-html-parser";
import { activeDefaultAccordianData } from "../../../selectors/Selectors";
import { useSelector } from "react-redux";

export type AccordionInfoType = {
  index: string;
  question: JSX.Element | string;
  answer: any;
  expanded: boolean;
  mid: String;
};

export interface AccordionBaseProps {
  accordionInfo: AccordionInfoType[];
  defaultExpandedSectionIds?: string[];
}

const FaqsBase = ({ accordionInfo }: AccordionBaseProps): JSX.Element => {
  const activeAcc = useSelector(activeDefaultAccordianData);

  return (
    <div  id="mainContent" autoFocus tabIndex={-1} >
      <H1 style={{fontWeight: '500'}}
          className=" mt-[40px] m-auto mx-auto w-[684px] text-center flex flex-row items-start">Frequently Asked
        Questions</H1>

      <AccordionGroup className="max-w-[684px] m-auto mt-[30px]">
        {accordionInfo?.map(({ mid, question, answer }, index) => {
          return (
            <Accordion
              key={`${mid}-accordion`}
              value={`${index}`}
              defaultExpanded={mid === activeAcc}
            >
              <AccordionHeader className="grow shrink basis-0 text-[14px] ">
                {question}
              </AccordionHeader>
              <AccordionPanel key={`${mid}-panel`} className="text-[14px]">
                {ReactHtmlParser(answer)}
              </AccordionPanel>
            </Accordion>
          );
        })}
      </AccordionGroup>
    </div>
  );
};

export default FaqsBase;
